import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';

import { FolderType } from '@/api/generated';
import Field from '@/components/fields/Field';
import LocationTreeSelect from '@/components/fields/Location/LocationTreeSelect';
import TextInput from '@/components/fields/TextInput';
import { useFieldPrefix } from '@/hooks/useFieldPrefix';
import OrganizationDropdownSelect from '@/views/fields/OrganizationDropdownSelect/OrganizationDropdownSelect';

const allowedLocationTypes = [FolderType.FOLDER, FolderType.SUB_FOLDER];

const LocationTab: React.FC = () => {
  const { t } = useTranslation(['processes']);
  const { watch } = useFormContext();
  const { getPrefixedFieldName } = useFieldPrefix();
  const organization = watch(getPrefixedFieldName('organization'));

  return (
    <Stack
      width="100%"
      sx={{
        '& .MuiFormLabel-root': { textAlign: 'start' },
        '& .MuiFormControl-root': { pb: 0 },
        '& .DropdownSelect-expandMoreIcon': { color: 'text.primary' }
      }}
    >
      <Field
        name="name"
        label={t('layouts.processCreate.processName')}
        component={TextInput}
        withFormControl
        innerProps={{ markAsRequired: true }}
      />

      <Field
        name="organization"
        label={t('layouts.processCreate.availableIn')}
        component={OrganizationDropdownSelect}
        withFormControl
        innerProps={{
          markAsRequired: true,
          sx: { alignSelf: 'flex-start', minWidth: 320 },
          isMulti: false
        }}
      />

      <Field
        name="location"
        label={t('layouts.processCreate.location')}
        component={LocationTreeSelect}
        withFormControl
        innerProps={{
          markAsRequired: true,
          sx: { maxWidth: 320 },
          organizationSlug: organization,
          allowedTypes: allowedLocationTypes
        }}
      />
    </Stack>
  );
};

export default LocationTab;
